export function generateShortUUID(props) {
  const uuidLength = props?.uuidLength ?? 10;
  const array = new Uint8Array(uuidLength);
  crypto.getRandomValues(array); // Fill the array with secure random values
  return Array.from(array, (byte) => byte.toString(36))
    .join('')
    .substring(0, uuidLength);
}
